import { connect } from "react-redux";
import CreatableSelect from "react-select/creatable";
import { Actions as ACTIONS } from "../../../store/actions/departmentActions";

const DepartmentRow = ({
	department,
	updateDepartment,
	employeeOptions,
	selectedManagers,
	level,
	currentDepartment,
	subDepartments,
	disabled,
}) => {
	return (
		<div
			className="departarment-type-line row"
			style={{ padding: "15px" }}
		>
			<div
				className="col-sm-6"
				style={{ paddingLeft: level ? level * 15 : 0 }}
			>
				<div className="form-material">
					<input
						className="form-control departament-type form-input"
						type="text"
						name="name"
						value={currentDepartment.name}
						disabled={disabled}
						autoComplete="off"
						onChange={(e) => {
							updateDepartment(currentDepartment.id, "name", e.target.value);
						}}
					/>
					<label htmlFor="material-text">Department Name</label>
				</div>
			</div>

			{/* <div className="col-sm-2">
            <div className="form-material">
                <input className="form-control" type="text" name="" disabled="disabled" value={1} style={{  textAlign: "center"}} />
                    <label># of Employees</label>
            </div>
            <div className="clearfix"></div>
        </div> */}

			<div className="col-sm-6">
				<div className="form-material">
					<CreatableSelect
						value={selectedManagers}
						isMulti={true}
						isClearable={true}
						options={employeeOptions}
						isDisabled={disabled}
						onChange={(selected) => {
							console.log("SELECTED", selected);
							updateDepartment(department.id, "managers", selected);
						}}
					/>
					<label htmlFor="example2-select2">Manager</label>
					<div className="clearfix"></div>
				</div>
			</div>

			{/* <div className="col-sm-3">
        <div className="form-material">

          <Select
            value={department.costCenter ? costCenterOptions.find(item => item.code == department.costCenter) : {}}
            options={costCenterOptions}
            onChange={(selected) => {
              updateDepartment(department.id, 'costCenter', selected)
            }}
          />
          <label htmlFor="example2-select2">Cost Center</label>
          <div className="clearfix"></div>
        </div>
      </div>

      <div className="col-sm-1" style={{ lineHeight: "50px" }}>
        <button
          className="btn btn-xs btn-default"
          type="button"
          data-toggle="tooltip"
          title="Add Sub Department"
          onClick={() => addDepartment(department.id)}
        >
          <PlusIcon style={{ height: "1.5em", float: "left" }} />
        </button>
        {department.new &&
          <button
            className="btn btn-xs btn-danger"
            type="button"
            data-toggle="tooltip"
            title="Remove"
            style={{ marginLeft: "5px" }}
            onClick={() => removeDepartment(department.id)}
          >
            <XMarkIcon style={{ height: "1.5em", float: "left" }} />
          </button>
        }
      </div> */}

			<div className="clearfix"></div>
			{subDepartments?.length > 0 && (
				<div
					className="row"
					style={{ padding: "0 15px" }}
				>
					{subDepartments?.map((department) => (
						<DepartmentRow
							key={department.id}
							department={department}
							level={level ? level + 1 : 1}
						/>
					))}
				</div>
			)}
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const employees = state.employees && state.employees.employeeListWithSalary;

	// TODO Need to join authorised managers
	const employeeOptions = employees
		? employees
				.filter(({ employee }) => employee)
				.map((employee) => ({
					value: employee.employee,
					label: `${employee.employeeName} ${employee.employeeSurname}`,
					manager: employee.employee,
				}))
		: [];

	const department = ownProps.department;

	const subDepartments =
		state.departments &&
		state.departments.departmentList &&
		state.departments.departmentList.filter(({ parent }) => parent == department.id);

	const costCenters = state.costCenter && state.costCenter.costCenterList;

	const costCenterOptions = costCenters
		? costCenters.map((item) => ({
				label: item.name,
				value: item.code,
		  }))
		: [];

	return {
		currentDepartment: department,
		selectedManagers: department?.managers,
		// employees,
		subDepartments,
		employeeOptions,
		costCenterOptions,
		disabled:
			state?.permissions?.my?.permissions?.settings == "Read" || state?.company?.settings?.status == "Archived",
		// ...state.employees,
	};
};

const mapDispatchToProps = (dispatch) => ({
	addDepartment: (parent) => dispatch(ACTIONS.addDepartment(parent)),
	removeDepartment: (id) => dispatch(ACTIONS.removeDepartment(id)),
	// saveDepartment: (id) => dispatch(ACTIONS.saveDepartment(id)),
	updateDepartment: (id, field, value) => dispatch(ACTIONS.updateDepartment(id, field, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentRow);
